import type React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './use-auth';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const step = useAuth((s) => s.step);
  if (step !== 'authed') return <Navigate to="/login" replace />;
  return <>{children}</>;
}
